import { getLocaleFromNavigator, init, register } from "svelte-i18n";
export { isLoading as localeIsLoading } from "svelte-i18n";
import { isIos } from "./env";

// TODO(duanei): We should improve the types in this file. i18n has awesome support for detecting
// typos on string keys. This is something we currently don't take advantage of.

// iOS sets locale with lowercase...
const fixLocale = (locale: string) => (isIos ? locale.toLowerCase() : locale);

// translate json to svelte-i18n format
const locale = (
  code: string,
  fn: () => Promise<{ default: { id: string; comment: string; string: string }[] }>,
) =>
  register(fixLocale(code), async () => {
    // resolve imported object
    const imported = (await fn()).default;
    return Object.fromEntries(imported.map(({ id, string }) => [id, string]));
  });

locale("en", () => import("./locale/en.json"));
locale("en-GB", () => import("./locale/en-GB.json"));
locale("pl", () => import("./locale/pl.json"));
locale("pt", () => import("./locale/pt.json"));
locale("pt-BR", () => import("./locale/pt-BR.json"));
locale("de", () => import("./locale/de.json"));
locale("es", () => import("./locale/es.json"));
locale("es-419", () => import("./locale/es-419.json"));
locale("es-ES", () => import("./locale/es-ES.json"));
locale("fr", () => import("./locale/fr.json"));
locale("fr-CA", () => import("./locale/fr-CA.json"));
locale("ru", () => import("./locale/ru.json"));
locale("zh-CN", () => import("./locale/zh-CN.json"));
locale("zh-TW", () => import("./locale/zh-TW.json"));
locale("ko", () => import("./locale/ko.json"));
locale("ja", () => import("./locale/ja.json"));

init({
  fallbackLocale: "en",
  initialLocale: fixLocale(getLocaleFromNavigator() ?? "en"),
  warnOnMissingMessages: true,
});
